import { COLORS, pickThemeFontStyles } from '@/theme';
import styled from 'styled-components';
import { Select } from '@/ui';

export const StyledPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledContentBlock = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  padding: 2rem;
  gap: 1.5rem;

  &&& .checkbox-column,
  .id-column {
    width: 2rem;
    padding: 1rem;
    min-width: 0;
  }

  .ant-table-thead > tr > th .ant-input,
  .ant-table-thead > tr > th .ant-select,
  .ant-table-thead > tr > th .ant-select-selector,
  .ant-table-thead > tr > th .ant-picker-input input {
    font-size: 0.75rem;
  }
`;

export const StyledTabContainer = styled.div`
  .ant-tabs-nav {
    margin: 0;
    width: fit-content;

    .ant-tabs-nav-wrap {
      background-color: transparent;
      overflow: hidden;
      width: fit-content;
    }

    .ant-tabs-nav-list {
      width: 100%;
    }

    .ant-tabs-ink-bar {
      background: ${COLORS.YELLOW_PRIMARY};
    }

    .ant-tabs-tab {
      margin: 0;
      padding: 0.6875rem 1rem;
      ${pickThemeFontStyles('14', '16', 'SMALL')};
      color: ${COLORS.CHARCOAL};
      letter-spacing: 0.0125rem;
      background: transparent;
      transition: all 0.2s ease-in-out;
      min-height: 2.6875rem;

      &:hover {
        background: ${COLORS.YELLOW_PRIMARY};
      }

      &.ant-tabs-tab-active {
        background: transparent;
        padding: 0.8125rem 1rem;
        ${pickThemeFontStyles('15', '16', 'SEMI_BOLD')};

        .ant-tabs-tab-btn {
          color: ${COLORS.BLACK_PRIMARY};
          letter-spacing: normal;
        }

        &:hover {
          background: ${COLORS.YELLOW_PRIMARY};
        }
      }
    }

    &::before {
      display: none !important;
    }
  }

  .ant-tabs-content-holder {
    background: ${COLORS.GRAY};
    padding: 2rem 1rem;
  }
`;

export const StyledSelect = styled(Select)`
  text-align: left;

  &&& {
    min-height: 2.875rem;
    height: auto;
    max-width: 100%;
    width: 100%;

    .ant-select-selection-placeholder {
      color: ${COLORS.GRAY_PRIMARY};
    }

    .ant-select-selector {
      min-height: 2.875rem;
      overflow: hidden;
      padding-top: 0.15rem;
      max-width: 100%;
    }

    .ant-select-selection-wrap {
      align-self: center;
    }

    .ant-select-selection-overflow {
      flex-wrap: nowrap !important;
      overflow: hidden;
      white-space: nowrap;
      max-width: 100%;

      & .ant-select-selection-overflow-item span {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        max-width: 8vw;
        line-height: 2rem;
      }

      & .ant-select-selection-overflow-item-rest div {
        border: none;
        color: ${COLORS.GRAY_PRIMARY};
      }

      & .ant-select-selection-overflow-item-suffix {
        padding-left: 0.25rem;
      }
    }

    .ant-select-clear {
      inset-inline-end: 0.25rem;
      top: 50%;
      width: fit-content;
      height: fit-content;
    }
  }
`;
